module.exports = __webpack_public_path__ + "img/success-big.3539e3f1.svg";